import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalAdequacyReviewComponent } from './modal-adequacy-review.component';

@NgModule({
  declarations: [ModalAdequacyReviewComponent],
  exports: [ModalAdequacyReviewComponent],
  imports: [A11yModule, CommonModule],
})
export class ModalAdequacyReviewModule {}
